import { Input } from 'components/ui/Input/Input'
import { DigitInput } from 'components/ui/Input/DigitInput'
import { IS_PROD } from '../../constants'

import { QrEntry } from './types'

type Props = {
  entries: QrEntry[]
  onChange: (containerId: string, newContainerId: string, seal: string) => void
  onRemove: (containerId: string) => void
  withSeal?: boolean
}

export const QrSealInputs = ({ entries, onChange, onRemove, withSeal = true }: Props) => {
  const renderSeal = (entry: QrEntry) => {
    if (!withSeal) return null

    return (
      <DigitInput
        value={entry.seal}
        placeHolder="Пломба"
        onChange={(seal) => onChange(entry.containerId, entry.containerId, seal)}
      />
    )
  }

  const renderRow = (entry: QrEntry) => (
    <div key={entry.previewUrl} className="qr-paste__row">
      {/* Id контейнера редактируется только на тестовой среде — для ручного ввода при отладке. */}
      <Input
        readOnly={IS_PROD}
        value={entry.containerId}
        onChange={(newContainerId) => onChange(entry.containerId, newContainerId, entry.seal)}
      />
      {renderSeal(entry)}
      <span
        className="qr-paste__remove"
        title="Удалить"
        onClick={() => onRemove(entry.containerId)}
      >
        ×
      </span>
    </div>
  )

  return <div className="qr-paste__rows">{entries.map(renderRow)}</div>
}
